module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.1068/img/pumpkin.svg"